{
  "title": "My Profiles",
  "empty": "Nothing here yet — invitations to complete a profile will show up on this page.",
  "active": {
    "title": "Active",
    "start": "Start your profile from {{tenantName}}",
    "continue": "Continue your profile from {{tenantName}}"
  },
  "completed": {
    "title": "Completed",
    "submittedOn": "Submitted {{date}}"
  },
  "detail": {
    "back": "Back to My Profiles",
    "self": "Self-profile",
    "matrix": "Your matrix",
    "evaluation": "Your evaluation",
    "preparing": "Your evaluation is being prepared — we'll email you when it's ready.",
    "notFound": "We couldn't find this profile."
  }
}
